import { BasicButton, Hidden } from '@orobix/orobix-fe-components'
import cx from 'classnames'
import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Observation } from '../../types'
import useStyles from './ThumbContextualMenu.styles'

export interface ThumbContextualMenuItem {
  label: string
  icon?: React.ReactNode
  type?: 'default' | 'destroy'
  disabled?: boolean
  title?: string
  onClick: () => void
}

export interface ThumbContextualMenuProps {
  showImageOverlay: (imageOverlay: boolean) => void
  items: ThumbContextualMenuItem[]
  observation: Observation
  showMenu: boolean
  setShowMenu: React.Dispatch<React.SetStateAction<boolean>>
}

export const ThumbContextualMenu = ({
  showImageOverlay,
  items,
  observation,
  showMenu,
  setShowMenu,
}: ThumbContextualMenuProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const menuRef = useRef<HTMLElement>(null)

  return (
    <div className={classes.contextualMenu}>
      <button
        type="button"
        onClick={() => setShowMenu(!showMenu)}
        className={classes.opener}
      >
        <span className={classes.dots}>
          <Hidden>{t('Image options')}</Hidden>
        </span>
      </button>

      {showMenu && (
        <nav className={classes.menu} ref={menuRef}>
          <ul>
            {items.map((i, k) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={k} title={i.title}>
                <div className={classes.button}>
                  <BasicButton
                    buttonType="button"
                    onClick={() => {
                      i.onClick()
                      showImageOverlay(false)
                      setShowMenu(false)
                    }}
                    block
                    wrapText
                    className={cx(
                      i.type === 'destroy' && classes.buttonDestroy
                    )}
                    disabled={i.disabled}
                  >
                    <span className={classes.buttonContent}>
                      <span className={classes.label}>{i.label}</span>
                    </span>
                  </BasicButton>
                </div>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  )
}

export default ThumbContextualMenu
